/**
 * 全局路由中间件 - 自动追踪（PC项目）
 * 在每次路由切换时生成新的 traceId
 */
import { generateTraceId } from '~/utils/tracking'

export default defineNuxtRouteMiddleware((to, from) => {
  // 只在客户端执行
  if (typeof window === 'undefined') {
    return
  }

  // 每次路由切换时生成新的 traceId
  const newTraceId = generateTraceId()

  console.log(`🔄 路由切换追踪 (PC) - 新 traceId: ${newTraceId}`, {
    from: from?.path,
    to: to.path
  })
})
